import { GetterTree, MutationTree, ActionTree } from 'vuex'
import Vue from 'vue'
import * as T from '@/types'

import api from '@/api'
import crud from '@/store/store-crud'

import { mixin } from '@/store/utils'

const INITIAL_STATE: () => Partial<T.Store.CasesState> = () => ({
    loading: false,
    loaded: false,
    saving: false,
    saved: false,
    deleting: false,
    sorts: {updatedAt: false},
    filters: {},
})

const getters: GetterTree<T.Store.CasesState, T.Store.RootState> = {

    filters: (state) => state.filters,

    sorts: (state) => state.sorts,

    sortKeys: (state) => Object.keys(state.sorts),

    isAscending: (state) => (key: keyof T.Case) => {
        if (!state.sorts || !state.sorts[key]) return false
        return state.sorts[key]
    },
}

const mutations: MutationTree<T.Store.CasesState> = {

    setFilter (state, payload: { key: keyof T.Case, value: any }) {
        Vue.set(state.filters, payload.key, payload.value)
    },

    setFilters (state, filters) {
        state.filters = filters
    },

    removeFilter (state, payload: { key: keyof T.Case }) {
        Vue.delete(state.filters, payload.key)
    },

    clearFilters (state) {
        state.filters = {}
    },

    applySort (state, payload: { key: keyof T.Case, ascending: boolean }) {
        Vue.set(state.sorts, payload.key, payload.ascending)
    },

    setSorts (state, sorts) {
        state.sorts = sorts
    },
}

const actions: ActionTree<T.Store.CasesState, T.Store.RootState> = {

    async refresh ({ commit, getters }) {
        commit('setLoading', true)
        try {
            const items = await api.cases.all(getters.filters, {sort: getters.sorts})
            commit('setItems', items)
        } catch (error) {
            console.log('Refresh error:', error)
        } finally {
            commit('setLoading', false)
        }
    },

    setFilter ({ commit }, payload: { key: keyof T.Case, value: any }) {
        const { key, value } = payload
        commit('setFilter', { key, value })
    },

    removeFilter ({ commit }, payload: { key: keyof T.Case }) {
        const { key } = payload
        commit('removeFilter', { key })
    },

    clearFilters ({ commit }) {
        commit('clearFilters')
    },

    applySort ({ commit }, payload: { key: keyof T.Case, value: any } ) {
        const { key, value } = payload
        commit('applySort', {key, ascending: value})
    },
}

const module = (mixin<T.Store.CasesState, T.Store.RootState>())(
    [crud<T.Case>(api.cases)],
    // [crud<T.Case>(api.files), selectable<T.Case>()],
    {
        namespaced: true,
        state: INITIAL_STATE(),
        actions,
        getters,
        mutations,
    },
)

export default module
